module.exports = ".card-1-2 {\n  width: 50%; }\n\n.top-20 {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/ministers/ver-postulacion/ver-postulacion.component.scss
// module id = ./src/app/admin/pages/ministers/ver-postulacion/ver-postulacion.component.scss
// module chunks = main